import CTAButton from '@/components/shared/CTAButton'

export function CompensationIntro({ className = '' }) {
  return (
    <section className={`w-full pt-12 sm:pt-16 ${className}`}>
      <div className="mx-auto max-w-6xl px-4">
        <h2 className="text-foreground mb-4 text-center text-4xl font-black sm:mb-6 sm:text-5xl">
          FIND OUT WHETHER YOU MAY BE ENTITLED TO COMPENSATION
        </h2>

        <p className="text-foreground text-center text-lg">
          Great news, the Financial Conduct Authority (FCA) has announced a mass
          redress scheme. It&apos;s estimated that up to{' '}
          <span className="font-raleway-numbers">37%</span>
          <sup style={{ fontSize: '0.7em', verticalAlign: 'super' }}>4</sup> of
          vehicles purchased on finance were mis-sold, including some lenders
          allowing higher interest rates to be charged, so you could have
          overpaid! Millions of people are unknowingly affected.
          <br />
          <br />
          Your household could receive up to{' '}
          <strong>
            £2,086
            <sup style={{ fontSize: '0.7em', verticalAlign: 'super' }}>1</sup>
          </strong>
          . That&apos;s because the average household contains 2 adults, our
          analysis identifies an average of 3.4 vehicle finance agreements per
          person, and around 37% of agreements may be affected. With average
          compensation estimated at £829 per eligible agreement, many households
          could have significant compensation opportunities. Be part of a
          potential payout worth up to <strong>£10 billion</strong>
          {'! '}It&apos;s estimated that around{' '}
          <strong>
            <span className="font-raleway-numbers">12.1</span> million
          </strong>{' '}
          finance agreements were affected, meaning many drivers could be
          entitled to compensation.
          <br />
          <br />
          Car & motor finance claims have been featured in{' '}
          <strong>BBC News</strong>, <strong>ITV</strong>, and{' '}
          <strong>The Telegraph</strong>.
          <br />
          <br />
          <span className="text-lg">
            Please be aware that you can make a free motor finance mis-selling
            claim directly with your lender, through the FCA redress scheme, or
            via the Financial Ombudsman Service. We can do the work for you, but
            you do not need to use a claims management company or law firm to
            make a claim.
          </span>
          <br />
          <br />
          <span className="text-lg">
            Please see our Key Information for further details.
          </span>
        </p>

        <div className="mt-8 mb-8 text-center">
          <CTAButton />
        </div>
      </div>
    </section>
  )
}

export default CompensationIntro
